



































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import {GCICategoryListRes} from '@/model/dto/res/contents/get-category-list-res';
import {PUUDataReq, PostUpsertUserReq} from '@/model/dto/req/user/post-upsert-user-req';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class UsersList extends Vue {
  /** Data **/

  public $refs!: {
    form: HTMLElement
  };

  /** Computed **/
  get users() {
    return userModule.userInfo;
  }

  get upsertStatus() {
    return userModule.upsertStatus;
  }

  get text() {
    return {
      title: GlobalConstants.TEXT.CATEGORYMANAGE.TITLE,
      label: GlobalConstants.TEXT.CATEGORYMANAGE.LABEL,
      key: GlobalConstants.TEXT.CATEGORYMANAGE.KEY,
      minValue: GlobalConstants.TEXT.CATEGORYMANAGE.MIN.VALUE,
      maxValue: GlobalConstants.TEXT.CATEGORYMANAGE.MAX.VALUE,
      minText: GlobalConstants.TEXT.CATEGORYMANAGE.MIN.TEXT,
      maxText: GlobalConstants.TEXT.CATEGORYMANAGE.MAX.TEXT,
      required: GlobalConstants.TEXT.CATEGORYMANAGE.REQUIRED,
      uniq: GlobalConstants.TEXT.CATEGORYMANAGE.UNIQ,
      regex: GlobalConstants.TEXT.CATEGORYMANAGE.REGEX,
      saveConfirmation: GlobalConstants.TEXT.CATEGORYMANAGE.SAVECONFIRMATION,
      allow: GlobalConstants.TEXT.ARROW,
      aconfirmation: GlobalConstants.TEXT.ALLOWCONFIRMATION,
    };
  }

  /** Watch **/
  @Watch('upsertStatus')
  private async onUpsertStatus() {
    await userModule.requestUserListInfo();
  }

  /** Methods **/
  private onClick(user: any) {
    userModule.updateSelectUserInfo(user);
    userModule.updateIsUsersFormDialog(!userModule.isUsersFormDialog);
  }

  private add() {
    userModule.updateSelectUserInfo({
      user_name: '',
      type: '',
      password: '',
      email: ''
    });
    userModule.updateIsUsersFormDialog(!userModule.isUsersFormDialog);
  }
  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {
    appModule.startLoading();
    await userModule.requestUserListInfo();
    appModule.stopLoading();
  }

}
